/* eslint-disable no-unused-vars */
import React, { useState, useEffect, createRef } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Modal,
  Select,
} from '@material-ui/core'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Typography from '@mui/material/Typography'
import { Autocomplete, Tab, Tabs, TextField } from '@mui/material'
import ReactTooltip from 'react-tooltip'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import CancelIcon from '@mui/icons-material/Cancel'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import {
  UpdateStatusFormMonitoringAndEvaluation,
  insertMonitoringAndEvaluationQuestionnaireAnswers,
  uploadReportCuestionary,
} from '../../../services/MonitoreoYEvaluacion/create'
import swal from 'sweetalert'
import {
  getAdaptabilityIndicators,
  getAdaptabilityQuestionsME,
  getMonitoringAndEvaluationQuestionnaireAnswersById,
} from '../../../services/MonitoreoYEvaluacion/get'
import Moment from 'moment'
import { useAuthentication } from '../../../context/authenticationContext'
import { useHistory } from 'react-router-dom'
import FormQuestions from './FormQuestions'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

export const Cuestionary = ({ IdQuestionnaireAnswer }) => {
  const { userIDB2C } = useAuthentication()
  const history = useHistory()
  const [popupVisible, setPopupVisible] = useState(false)
  const [loading, setLoading] = useState(true)
  const [questions, setQuestions] = useState({})
  const [QuestionnaireAnnexAnswer, setQuestionnaireAnnexAnswer] = useState([])
  // todo modificar el validate
  const [validate, setValidate] = useState(false)
  const [validForm, setValidForm] = useState(false)
  const [valuePanel, setValuePanel] = useState(0)
  const [adaptabilityIndicador, setAdaptabilityIndicador] = useState([])
  const [Observations, setObservations] = useState('')
  const [loadingRegister, setLoadingRegister] = useState(false)

  const childRef = createRef()

  const GeneralDataSchema = Yup.object().shape({
    ComplianceDate: Yup.date()
      .required('Este campo es requerido')
      .typeError('Este campo es requerido'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdQuestionnaireAnswer: IdQuestionnaireAnswer,
      IdAdaptationAction: '',
      ComplianceDate: null,
      IdFormAction: 57,
      IdUserAzureB2C: userIDB2C,
      Draft: false,
      MiPyme: '',
      SubprojectName: '',
      GenerateIndicator: 1,
      Indicator_Description: '',
      IdProcess: 1,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      handleGuardar(values, false)
    },
  })
  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const handleChange = (event, newValue) => {
    setValuePanel(newValue)
  }

  const handleCancelCuestionary = async () => {
    try {
      const response = await UpdateStatusFormMonitoringAndEvaluation(
        IdQuestionnaireAnswer,
        userIDB2C,
        16,
        Observations,
      )
      if (response.Success)
        swal({
          title:
            '¡Cuestionario de Monitoreo y Evaluación cancelado exitosamente!',
          icon: 'success',
        })
    } catch (error) {}
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  }

  const getMonitoringAndEvaluationQuestionnaireAnswers = async () => {
    try {
      const response = await getMonitoringAndEvaluationQuestionnaireAnswersById(
        IdQuestionnaireAnswer,
      )
      if (response.Success) {
        formik.setValues({
          ...formik.values,
          IdQuestionnaireAnswer: response.Data.IdQuestionnaireAnswer,
          MiPyme: response.Data.MiPyme,
          SubprojectName: response.Data.SubprojectName,
          AdaptationDescription: response.Data.AdaptationDescription,
          StatusDescription: response.Data.StatusDescription,
          ComplianceDate:
            response.Data.ComplianceDate !== null
              ? Moment(response.Data.ComplianceDate)
                  .format('YYYY-MM-DD')
                  .toString()
              : Moment(response.Data.CreationDate)
                  .format('YYYY-MM-DD')
                  .toString(),
          Draft: response.Data.Draft,
          IdDisbursements: response.Data.IdDisbursements,
          IdAdaptationAction: response.Data.IdAdaptationAction,
          CreationDate: response.Data.CreationDate,
          Indicator_Description:
            response.Data.Indicator_Description !== null
              ? response.Data.Indicator_Description
              : '',
        })

        // // setQuestionnaireAnnexAnswer(response.Data.QuestionnaireAnnexAnswer)
        if (response.Data.QuestionnaireAnnexAnswer !== null) {
          if (response.Data.QuestionnaireAnnexAnswer) {
            setQuestionnaireAnnexAnswer(response.Data.QuestionnaireAnnexAnswer)
          }
        }

        // TODO: validar cuando el idAdaptation === 24

        if (response.Data.IdAdaptationAction !== 24) {
          getQuestion(response.Data.IdAdaptationAction)
        } else {
          getIndicador()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleSubmit = () => {
    Swal.fire({
      title: 'Confirmación de Registro',
      text: '¿Está seguro de realizar la acción , una vez registrado no podrá hacer cambios en el Cuestionario',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleGuardar(formik.values, false)
      } else {
        Swal.close()
      }
    })
    // }
  }

  useEffect(() => {
    getMonitoringAndEvaluationQuestionnaireAnswers()
  }, [])

  const getQuestion = async (IdAdaptationAction) => {
    try {
      const response = await getAdaptabilityQuestionsME(IdAdaptationAction)
      if (response.Success) {
        setQuestions(response.Data[0])
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getIndicador = async () => {
    try {
      const response = await getAdaptabilityIndicators()
      if (response.Success) {
        setAdaptabilityIndicador(response.Data)
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleGuardar = async (values, borrador) => {
    setLoadingRegister(true)
    try {
      // if (!borrador) {
      //   setValidate(true)
      // }
      const removeArray = QuestionnaireAnnexAnswer.slice(0, 1).concat(
        QuestionnaireAnnexAnswer.slice(1 + 1, QuestionnaireAnnexAnswer.length),
      )
      const object = {
        ...values,
        QuestionnaireAnnexAnswer: removeArray,
        Draft: borrador,
      }

      const response = await insertMonitoringAndEvaluationQuestionnaireAnswers({
        ...object,
      })
      if (response.Success) {
        setLoadingRegister(false)
        if (borrador)
          swal({
            title: '¡Datos guardados exitosamente!',
            icon: 'success',
          })
        else {
          uploadReport(
            response.Data.IdQuestionnaireAnswer,
            response.Data.IdFormHistory,
          )
          setLoadingRegister(false)
        }
      }
    } catch (error) {
      setLoadingRegister(false)
      console.log(error)
    }
  }

  const uploadReport = async (idForm, IdFormHistory) => {
    try {
      const response = await uploadReportCuestionary(
        idForm,
        userIDB2C,
        IdFormHistory,
      )
      if (response.Success) {
        swal({
          title: 'Formulario Enviado Exitosamente',
          icon: 'success',
          button: 'Entendido',
        })
        history.push('/')
      }
    } catch (error) {
      console.log(error)
    }
  }
  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (
          Object.entries(values).length === 0 &&
          formik.values.ComplianceDate !== null
        ) {
          handleSubmit()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('Error', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
    })
  }

  const onHiding = async () => {
    setPopupVisible(false)
  }

  const handleClose = () => {
    // todo eliminar
    setLoadingRegister(false)
    formik.resetForm()
    history.goBack()
  }

  return (
    <>
      {!loading ? (
        <div
          id="wizard-form"
          style={{
            overflow: 'hidden',
            backgroundColor: 'white',
            boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
          }}
        >
          <Box>
            <Grid
              container
              md={12}
              sm={12}
              spacing={1}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <Grid item>
                <div
                  data-tip
                  onClick={handleClose}
                  data-for="exitPop"
                  style={{
                    backgroundColor: '#014b96',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                >
                  <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="exitPop"
                    effect="solid"
                    backgroundColor="#014b96"
                  >
                    <span>Regresar</span>
                  </ReactTooltip>
                </div>
              </Grid>

              <Grid item>
                <div
                  data-tip
                  onClick={() => {
                    setPopupVisible(true)
                  }}
                  data-for="cancelPop"
                  style={{
                    backgroundColor: 'red',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                >
                  <CancelIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="cancelPop"
                    effect="solid"
                    backgroundColor="red"
                  >
                    <span>Cancelar</span>
                  </ReactTooltip>
                </div>
              </Grid>

              <Grid item>
                <div
                  data-tip
                  data-for="savePop"
                  style={{
                    backgroundColor: '#5cb85c',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleGuardar(formik.values, true)
                  }}
                >
                  <SaveIcon />
                </div>
                <ReactTooltip
                  id="savePop"
                  effect="solid"
                  backgroundColor="#5cb85c"
                >
                  <span>Guardar </span>
                </ReactTooltip>
              </Grid>
            </Grid>

            {/* Popup Cancel */}
            {/* <Popup
              title="Acciones disponible IFI"
              showTitle={true}
              width={600}
              height={350}
              visible={popupVisible}
              hideOnOutsideClick
              onHiding={onHiding}
            >
              <Grid container spacing={1}>
                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Acción</label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <Select
                        id="IdProject"
                        name="IdProject"
                        variant="outlined"
                        // displayEmpty={true}
                        value={1}
                        // disabled
                      >
                        <MenuItem value={1}>Cancelar</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Observaciones</label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <textarea
                        id="ClimateThreat"
                        placeholder="Observaciones"
                        customInput={TextField}
                      ></textarea>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid className="buttonsPYME">
                  <Button className="cancelButton" onClick={onHiding}>
                    Cancelar
                  </Button>

                  <Button className="confirmButton">Guardar</Button>
                </Grid>
              </Grid>
            </Popup> */}
            <Modal
              open={popupVisible}
              onClose={onHiding}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modalPYME">
                <Grid className="modalTitle">
                  <Typography
                    id="modal-modal-title"
                    style={{ fontWeight: '900' }}
                    variant="h6"
                    component="h2"
                  >
                    Acciones disponibles IFI
                  </Typography>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Acción</label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <Select
                        id="IdProject"
                        name="IdProject"
                        variant="outlined"
                        value={1}
                        disabled
                      >
                        <MenuItem value={1}>Cancelar</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Observaciones</label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <textarea
                        id="ClimateThreat"
                        placeholder="Observaciones"
                        customInput={TextField}
                        onChange={(e) => {
                          setObservations(e.target.value)
                        }}
                      ></textarea>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid className="buttonsPYME">
                  <Button className="cancelButton" onClick={onHiding}>
                    Cancelar
                  </Button>

                  <Button
                    className="confirmButton"
                    onClick={() => handleCancelCuestionary()}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Box>
            </Modal>

            {/* Fin popup Cancel */}
            <div className="pymeDiv">
              <h1 className="pymeTitle">
                Cuestionario de Monitoreo y Evaluación
              </h1>
              <p className="pymeDescription">
                Proporcione la información solicitada para iniciar Monitoreo y
                Evaluación
              </p>
            </div>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.1. Nombre de la MIPYME
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="MiPymeName"
                      name="MiPymeName"
                      style={{ width: '100%' }}
                      variant="outlined"
                      disabled
                      value={formik.values.MiPyme}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.2. Título del Subproyecto financiado
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="MiPymeName"
                      name="MiPymeName"
                      style={{ width: '100%' }}
                      variant="outlined"
                      disabled
                      value={formik.values.SubprojectName}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.2. Indicador de adaptación
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="MiPymeName"
                      name="MiPymeName"
                      style={{ width: '100%' }}
                      variant="outlined"
                      value={formik.values.AdaptationDescription}
                      disabled
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              spacing={1}
              style={{
                marginTop: '2%',
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ fontWeight: 'bold' }}>
                    1.4 Partiendo de la medida de adaptación., la MIPYME se
                    compromete a: <br /> El cumplimiento del ítem que la mipyme
                    seleccione será verificado por la IFI, para asegurar el
                    otorgamiento del premio, el cual está sujeto a
                    disponibilidad de fondos.
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* Componente para generar las preguntas */}
                  {formik.values.IdAdaptationAction !== 24 ? (
                    <FormControl fullWidth>
                      <FormQuestions
                        questionStructure={questions}
                        setQuestionnaireAnnexAnswer={
                          setQuestionnaireAnnexAnswer
                        }
                        QuestionnaireAnnexAnswer={QuestionnaireAnnexAnswer}
                        formikData={formik.values}
                        validate={validate}
                        setValidate={setValidate}
                        setValidForm={setValidForm}
                        ref={childRef}
                        handleSubmit={handleSubmit}
                        validateFormStatus={validateFormStatus}
                      />
                    </FormControl>
                  ) : (
                    <Grid container spacing={1} className="input__container">
                      <Grid item xs={12} sm={12} md={12}>
                        <label className="responsiveLabel">
                          1. Ingrese el Indicador de Impacto
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <Box sx={{ width: '100%' }}>
                          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                              value={valuePanel}
                              onChange={handleChange}
                              aria-label="basic tabs example"
                            >
                              <Tab
                                label="Digitar Indicador"
                                {...a11yProps(0)}
                              />
                              {adaptabilityIndicador.length > 0 && (
                                <Tab
                                  label="Seleccionar Indicador"
                                  {...a11yProps(1)}
                                />
                              )}
                            </Tabs>
                          </Box>
                          <TabPanel value={valuePanel} index={0}>
                            <Grid item xs={12} sm={12} md={12}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Indicator_Description}"
                                  name="Indicator_Description}"
                                  style={{ width: '100%' }}
                                  variant="outlined"
                                  value={formik.values.Indicator_Description}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      'Indicator_Description',
                                      e.target.value,
                                    )
                                  }}
                                />
                              </FormControl>
                            </Grid>
                          </TabPanel>
                          <TabPanel value={valuePanel} index={1}>
                            <Grid item xs={12} sm={12} md={12}>
                              <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                  disablePortal
                                  id="combo-box-demo"
                                  getOptionLabel={(option) =>
                                    option?.QuestionName
                                  }
                                  options={adaptabilityIndicador}
                                  value={formik.values.PrincipalQuestion}
                                  sx={{ width: '100%' }}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                />
                              </FormControl>
                            </Grid>
                          </TabPanel>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.5. Fecha de cumplimiento de la medida de adaptación
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="ImplementationDateStart"
                      type="date"
                      name="ImplementationDateStart"
                      variant="outlined"
                      sx={{ width: '100%' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) =>
                        formik.setFieldValue('ComplianceDate', e.target.value)
                      }
                      value={formik.values.ComplianceDate}
                      error={formik.errors.ComplianceDate}
                    />
                    {formik.errors.ComplianceDate ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.ComplianceDate}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">1.6. Estado</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="MiPymeName"
                      name="MiPymeName"
                      style={{ width: '100%' }}
                      variant="outlined"
                      value={formik.values.StatusDescription}
                      disabled
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button
                  className="confirmButton"
                  type="button"
                  onClick={(e) => {
                    setValidate(true)
                  }}
                  disabled={loadingRegister}
                  // onClick={valid}
                >
                  Registrar
                </Button>
              </Grid>
            </Grid>
          </Box>
        </div>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}
